import type { SchedulesContracAmendments } from '@libs/data-access/entities'
import type Immutable from 'immutable'

import { formatToWeekISO } from '../../../../../services/utils'

export const getContractTimeByWeek = (
  weeksInRange: Immutable.List<moment.Moment>,
  contractTime: number | undefined,
  amendments: SchedulesContracAmendments[]
) => {
  return weeksInRange.toArray().reduce((memo, week) => {
    const currentWeekMonday = week
      .clone()
      .startOf('isoWeek')
      .format('YYYY-MM-DD')
    const currentWeekSunday = week.clone().endOf('isoWeek').format('YYYY-MM-DD')

    const amendment = amendments?.find(
      amendment =>
        amendment?.contract_start <= currentWeekSunday &&
        (!amendment?.contract_end ||
          amendment?.contract_end >= currentWeekMonday)
    )

    if (amendment) {
      return {
        ...memo,
        [formatToWeekISO(week)]: amendment?.contract_time
      }
    }

    return {
      ...memo,
      [formatToWeekISO(week)]: contractTime
    }
  }, {})
}
